import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "step__basic" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "2. Подача осуществляется самостоятельно или по доверенности", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_Dropdown, {
        modelValue: _ctx.send_type_title,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.send_type_title) = $event)),
        editable: "",
        options: _ctx.send_type_options,
        optionLabel: "name",
        placeholder: _ctx.send_type_default.name,
        style: {"width":"520px"},
        onChange: _ctx.send_type_change
      }, null, 8, ["modelValue", "options", "placeholder", "onChange"])
    ])
  ]))
}